const breakpoints = {
  xs: 768,
  sm: 1024,
  md: 1200,
  lg: 1600,
  xl: 2100,
}

export default breakpoints
